import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { UserService } from 'app/core/user/user.service';

export const AuthGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
    const router: Router = inject(Router);
    const userService = inject(UserService);
    // userService.getSettings().subscribe(setting => userService.setting = setting);
    //get the token from sessionStorage
    const tokenData = sessionStorage.getItem('access_token');
    try {
        const token = JSON.parse(tokenData || '{}')?.accessToken;

        if (token) {
            //token exists
            userService.getSettings().subscribe(setting => userService.setting = setting);
            return true;
        } else {
            //no token, redirect to login
            router.navigate(['/login']);
            return false;
        }
    } catch (e) {
        console.error('AuthGuard error parsing token:', e);
        router.navigate(['/login']);
        return false;
    }
};
